import React, {FC} from 'react';
import shed from '../../assets/images/icon-page/sheds.png';


const ShedIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Shed Icon'}) => {
    return (
        <img
            src={shed}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default ShedIcon;
